import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth16getGetScreenTruthProposalsResponseSchema = jsonObject
export type tcpscreentruth16getGetScreenTruthProposalsResponse = z.infer<typeof tcpscreentruth16getGetScreenTruthProposalsResponseSchema>
